<script>
import { Router, Route, Link } from "svelte-navigator";
import { _ } from 'svelte-i18n';
import { MetaTags } from 'svelte-meta-tags';

import Meter from "./Meter.svelte";
import MeterForm from "./MeterForm.svelte";
import Links from "./Links.svelte";
import './i18n';
</script>

<Router>
  <main>
    <header>
      <Link to="/">
        <img src="/img/logo.png" class="logo" alt="Home" />
      </Link>
    </header>
    <Route path="m/:meter" let:params>
      <Meter meter={params.meter} />
    </Route>
    <Route>
      <MetaTags title={$_('home.title')} description={$_('home.description')} />
      <h1>{$_('home.convertMeters')}</h1>
      <MeterForm />
      <Links title="Common meters to inches conversions" />
    </Route>
  </main>
</Router>
